import React, { useState } from 'react';
import { Grid, Autocomplete, TextField, Button } from '@mui/material';

const PatientDetailsSingleAnalyteAnalysisSelector = ({
  categoryOptions = [],
  analyteOptions = [],
  selectedCategory,
  setSelectedCategory,
  selectedAnalyte,
  setSelectedAnalyte,
  classes,
  onSubmit
}) => {



    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
            <Autocomplete
                fullWidth
                className={classes?.muiInputs}
                options={categoryOptions}
                value={categoryOptions.find(opt => opt.value === selectedCategory) || null}
                onChange={(event, newValue) => {
                setSelectedCategory(newValue ? newValue.value : '');
                setSelectedAnalyte(null);
                }}
                renderInput={params => (
                <TextField
                    {...params}
                    label="Select Analyte Category"
                    variant="outlined"
                    size="small"
                />
                )}
                isOptionEqualToValue={(option, value) => option.value === value?.value}
            />
            </Grid>
            <Grid item xs={12} sm={4}>
            <Autocomplete
                fullWidth
                className={classes?.muiInputs}
                options={analyteOptions}
                value={selectedAnalyte || null}
                onChange={(event, newValue) => setSelectedAnalyte(newValue)}
                renderInput={params => (
                <TextField
                    {...params}
                    label="Select Analyte to Plot"
                    variant="outlined"
                    size="small"
                />
                )}
                isOptionEqualToValue={(option, value) => option.value === value?.value}
                disabled={!selectedCategory}
            />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Button
                fullWidth
                variant="contained"
                onClick={() => onSubmit && onSubmit({ analyte: selectedAnalyte })}
                disabled={!selectedCategory || !selectedAnalyte}
                >
                Submit
                </Button>
            </Grid>
        </Grid>
    );
};

export default PatientDetailsSingleAnalyteAnalysisSelector;